export enum OrderTabType {
  Open = 0,
  Sent = 1,
  Delivered = 2,
  All = 3
}
